export const MOBILE_QUERY = "(max-width: 767.98px)";

const DEFAULTS = { lanes: "all", service: "all", blocks: "show", schedules: "show", scheduled: "all" };

export const ALL_FACILITIES = "all";

export function stateParams({ date, view, tab, facility, lanes, service, blocks, schedules, scheduled, categories, hiddenStatuses }) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (view) params.set("view", view);
  if (tab && tab !== "calendar") params.set("tab", tab);
  if (facility && facility !== ALL_FACILITIES) params.set("facility", facility);
  const filters = { lanes, service, blocks, schedules, scheduled };
  Object.keys(DEFAULTS).forEach((name) => {
    const value = filters[name];
    if (value && value !== DEFAULTS[name]) params.set(name, value);
  });
  (categories || []).forEach((category) => params.append("categories[]", category));
  (hiddenStatuses || []).forEach((status) => params.append("hidden_statuses[]", status));
  return params;
}

export function fetchParams(state, { mobile, limits }) {
  const params = stateParams(state);
  if (!params.has("facility")) params.set("facility", ALL_FACILITIES);
  if (mobile) params.set("layout", "mobile");
  Object.entries(limits || {}).forEach(([kind, limit]) => {
    if (limit) params.set(`${kind}_limit`, String(limit));
  });
  return params;
}

export function facilityChange(current, picked, limits) {
  if (picked === null || picked === undefined || picked === current) return { facility: current, limits };
  return { facility: picked, limits: {} };
}

export function resetDetail() {
  return { ...DEFAULTS, facility: ALL_FACILITIES, categories: [], hiddenStatuses: [], reset: true };
}

export function applyFilter(state, limits, detail) {
  const { reset, facility, ...filters } = detail;
  const change = facilityChange(state.facility, facility, limits);
  return { state: { ...state, ...filters, facility: change.facility }, limits: reset ? {} : change.limits };
}

function filterFlags({ lanes, service, blocks, schedules, scheduled, facility, categories, hiddenStatuses }) {
  return [
    !!lanes && lanes !== "all",
    !!service && service !== "all",
    blocks === "hide",
    schedules === "hide",
    scheduled === "only",
    !!facility && facility !== ALL_FACILITIES,
    (categories || []).length > 0,
    (hiddenStatuses || []).length > 0,
  ];
}

export function activeCount(state, customOrder = false) {
  return filterFlags(state).filter(Boolean).length + (customOrder ? 1 : 0);
}

export function resettable(state) {
  return filterFlags(state).some(Boolean);
}
